import { PermissionGroup } from "@core/entities";
import { createAction, props } from "@ngrx/store";
import { CreatePermissionGroup, RolesState, UpdatePermissionGroup } from "../../entities";

export enum RolesAction {
  ClearAll = "[ROLES] Clear All Roles",
  SetUi = "[ROLES] Roles UI",
  WipeUpsertState = "[ROLES] Wipe Upsert State",
  SetPermissionGroups = "[ROLES] Set Permission Groups",
  ListPermissionGroups = "[ROLES] List Permission Groups",
  SetSelectedPermissionGroup = "[ROLES] Set Selected Permission Group",
  ModifySelectedPermissionGroup = "[ROLES] Modify Selected Permission Group",
  UpdatePermissionGroups = "[ROLES] Update Permission Group",
  CreatePermissionGroups = "[ROLES] Create Permission Group",
}

export const clearAll = createAction(RolesAction.ClearAll);
export const setUi = createAction(RolesAction.SetUi, props<{ ui: Partial<RolesState["ui"]> }>());
export const wipeUpsertState = createAction(RolesAction.WipeUpsertState);
export const setPermissionGroups = createAction(RolesAction.SetPermissionGroups, props<{ payload: PermissionGroup[] }>());
export const createPermissionGroups = createAction(RolesAction.CreatePermissionGroups, props<{ payload: CreatePermissionGroup }>());
export const updatePermissionGroups = createAction(RolesAction.UpdatePermissionGroups, props<{ payload: UpdatePermissionGroup }>());
export const listPermissionGroups = createAction(RolesAction.ListPermissionGroups);
export const modifySelectedPermissionGroup = createAction(
  RolesAction.ModifySelectedPermissionGroup,
  props<{ payload: Partial<PermissionGroup> }>()
);
export const setSelectedPermissionGroup = createAction(
  RolesAction.SetSelectedPermissionGroup,
  props<{ payload: PermissionGroup | undefined }>()
);
